export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'long', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
/**
 * @param choice number
 * @param choicesLength number
 * http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html#cs
 */
export function pluralizationRules(choice, choicesLength) {
	let result = 3; //many
	if (choice === 0) {
		return 0; //Special case zero
	}

	if (choice === 1) {
		result = 1; //one
	}

	if (choice >= 2 && choice <= 4) {
		result = 2; //few
	}

	return Math.min(result, choicesLength - 1);
};

export const messages = {
    "login.form.title": "Přihlášení",
    "login.form.hint.user": "Uživatelské jméno",
    "login.form.hint.password": "Heslo",
    "login.form.checkbox.remember-me": "Pamatovat si mě",
    "login.form.button.sign-in": "Přihlásit se",
    "login.form.message.invalid-user-credentials": "Přihlašovací jméno nebo heslo je nesprávné.",
    "login.form.message.account-temporarily-locked": "Váš účet je dočasně zablokovaný. Zkuste to znovu za 5 min.",
    "login.form.message.user-required": "Zadejte přihlašovací jméno.",
    "login.form.message.password-required": "Zadejte heslo",
    "login.form.button.forgot-password": "Zapomněli jste heslo?",
    "error.mfa-required.title": "Nastavení 2FA",
    "error.mfa-required.message1": "K ochraně vašeho účtu je vyžadováno dvojfázové ověřování (2FA).",
    "error.mfa-required.message2": "Budete přesměrováni do nastavení svého účtu v online kontrolním panelu. Povolte 2FA, postupujte podle pokynů k nastavení a poté se vraťte sem.",
    "error.mfa-required.learnMore": "Další informace o 2FA",
    "error.mfa-required.continue": "Pokračovat",
    "error.root-admin-login.title": "SMART 403 – zakázáno",
    "error.root-admin-login.message": "Jste přihlášeni jako správce s právy jen pro čtení. Chcete-li přejít na konzoli Web Recovery, přihlaste se jako uživatel tenanta zákazníka nebo správce.",
    "error.server-busy.message": "Server je zaneprázdněný. Zkuste to znovu později.",
    "error.network-connection.title": "Chyba připojení k síti",
    "error.network-connection.message": "Zkontrolujte připojení k internetu a zkuste to znovu.",
    "error.internal-server-error.title": "Vnitřní chyba serveru",
    "error.internal-server-error.message": "Chcete-li tuto chybu vyřešit, obraťte se na podporu a uveďte podrobnosti chyby:",
    "error.internal-server-error.copy.button": "Kopírovat"
};
